import React, {useCallback, useEffect} from 'react';
import {loadDynamicBanner} from 'redux/slices/dynamicMultipleElementsSlice';
import CustomCarousel from "./CustomCarousel";
import {BANNER_TYPE} from "constants/commons";

const {useSelector, useDispatch} = require('react-redux');

const DynamicCarousel = ({section, mobile}) => {
  const {[section.value]: data} = useSelector(
    (state) => state.dynamicMultipleElements.dynamicBanner
  );
  return (
    <MemoizedDynamicCarousel data={data} section={section} mobile={mobile}/>
  );
};


export default React.memo(DynamicCarousel);

const DynamicCarouselContent = (
  {
    data, mobile = true,
    // showArrowButton = false,
    // showDotIndicator,
    section
  }) => {

  const {loading = false, error = "", init = false} = data ?? {};

  const dispatch = useDispatch();

  const fetchDynamicCarousel = useCallback(() => {
    dispatch(loadDynamicBanner(section.value));
  }, [section?.value]);



  useEffect(() => {
    if (!init && !loading && !error)
      fetchDynamicCarousel();
  }, [fetchDynamicCarousel, init, loading, error]);

  return (
    <CustomCarousel type={BANNER_TYPE.dynamic_banner} defaultAspectRatio={section.extras}
                    bannerList={data ?? ({loading: false, error: "", init: false, data: {page_info: {extras: section.extras}}})} mobile={mobile}
                    retry={fetchDynamicCarousel} className={`${mobile ? ""  : "app-side-pd "}app-top-mg`} showArrowButton={true} showDotIndicator={true} />
  );
};

const MemoizedDynamicCarousel = React.memo(DynamicCarouselContent);